import { createContext, useContext } from 'react';
import type { ChessRepsApi } from './client';

/** Context exposing the generated OpenAPI client to the component tree. */
export const ApiContext = createContext<ChessRepsApi | null>(null);

export function useApi(): ChessRepsApi {
  const api = useContext(ApiContext);
  if (api === null) {
    throw new Error('useApi must be used within an <ApiProvider>.');
  }
  return api;
}
